"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyAppHost = exports.LegacyAppUrl = exports.AppHost = exports.AppUrl = exports.DiscordUrl = exports.ForumUrl = exports.FileSafeHelpUrl = exports.HelpOfflineUrl = exports.HelpSecurityUrl = exports.HelpUrl = exports.PrivacyPolicyUrl = exports.WebsiteUrl = exports.SupportMailtoUrl = exports.SupportEmail = void 0;
exports.SupportEmail = 'help@standardnotes.com';
exports.SupportMailtoUrl = `mailto:${exports.SupportEmail}`;
exports.WebsiteUrl = 'https://standardnotes.com';
exports.PrivacyPolicyUrl = 'https://standardnotes.com/privacy';
exports.HelpUrl = 'https://standardnotes.com/help';
exports.HelpSecurityUrl = 'https://standardnotes.com/help/security';
exports.HelpOfflineUrl = 'https://standardnotes.com/help/59/can-i-use-standard-notes-totally-offline';
exports.FileSafeHelpUrl = 'https://standardnotes.com/filesafe';
exports.ForumUrl = 'https://standardnotes.com/forum';
exports.DiscordUrl = 'https://standardnotes.com/discord';
exports.AppUrl = 'https://app.standardnotes.com';
exports.AppHost = 'app.standardnotes.com';
exports.LegacyAppUrl = 'https://app.standardnotes.org';
exports.LegacyAppHost = 'app.standardnotes.org';
